import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Field from '../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import VideoRadioButtons from '../VideoRadioButtons'
import AdTikTokPreview from '../../../../AdTikTokEdit/AdTikTokPreview'

import tikTokCallToActionsList from '../../../../../../../constants/selectLists/tikTokCallToActionsList'
import { AD_TEXT, adTextMaxLength, CALL_TO_ACTION, LANDING_PAGE_URL, VIDEO } from '../../../../fields'
import { FILE_ID, FILE_URL } from '../../../../../../ReusableFormFields/AdFileUpload/fields'
import { VIDEO_THUMBNAIL_URL } from '../../fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [LANDING_PAGE_URL, AD_TEXT, FILE_ID, VIDEO_THUMBNAIL_URL]

function AdDetailsStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  const adData = useMemo(() => {
    return {
      ...values,
      [VIDEO]: { url: values[FILE_URL] }
    }
  }, [values])

  return (
    <Step stepTitle="Select video" handleContinue={handleContinue}>
      <AdTikTokPreview adData={adData} />

      <section className={drawerFormClasses.section}>
        <VideoRadioButtons formik={formik} />
        <FieldLabelWrapper label={t('Click through link')}>
          <Field formik={formik} name={LANDING_PAGE_URL} placeholder="Click Through Link" autoComplete="off" />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('What should the ad text be?')}>
          <Field formik={formik} name={AD_TEXT} placeholder="Text" autoComplete="off" maxLength={adTextMaxLength} />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('Call to action')}>
          <Field placeholder="Call To Action" formik={formik} name={CALL_TO_ACTION} options={tikTokCallToActionsList} />
        </FieldLabelWrapper>
      </section>
    </Step>
  )
}

export default AdDetailsStep
